// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/errors/v1/types.proto (package creativefabrica.errors.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CoinError, CoinErrorJson } from "../../coins/v1/types_pb";
import { file_creativefabrica_coins_v1_types } from "../../coins/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/errors/v1/types.proto.
 */
export const file_creativefabrica_errors_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CiVjcmVhdGl2ZWZhYnJpY2EvZXJyb3JzL3YxL3R5cGVzLnByb3RvEhljcmVhdGl2ZWZhYnJpY2EuZXJyb3JzLnYxIoQCCgVFcnJvchIyCgR0eXBlGAEgASgOMiQuY3JlYXRpdmVmYWJyaWNhLmVycm9ycy52MS5FcnJvclR5cGUSOQoKY29pbl9lcnJvchgCIAEoCzIjLmNyZWF0aXZlZmFicmljYS5jb2lucy52MS5Db2luRXJyb3JIABI6Cgpuc2Z3X2Vycm9yGAMgASgLMiQuY3JlYXRpdmVmYWJyaWNhLmVycm9ycy52MS5OU0ZXRXJyb3JIABJGChB2YWxpZGF0aW9uX2Vycm9yGAQgASgLMiouY3JlYXRpdmVmYWJyaWNhLmVycm9ycy52MS5WYWxpZGF0aW9uRXJyb3JIAEIICgZkZXRhaWwiCwoJTlNGV0Vycm9yIlAKD1ZhbGlkYXRpb25FcnJvchI9Cgp2aW9sYXRpb25zGAEgAygLMikuY3JlYXRpdmVmYWJyaWNhLmVycm9ycy52MS5GaWVsZFZpb2xhdGlvbiJECg5GaWVsZFZpb2xhdGlvbhINCgVmaWVsZBgBIAEoCRIOCgZyZWFzb24YAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkqbAoJRXJyb3JUeXBlEhoKFkVSUk9SX1RZUEVfVU5TUEVDSUZJRUQQABITCg9FUlJPUl9UWVBFX0NPSU4QARITCg9FUlJPUl9UWVBFX05TRlcQAhIZChVFUlJPUl9UWVBFX1ZBTElEQVRJT04QA0JPWk1naXRodWIuY29tL2NyZWF0aXZlZmFicmljYS9zY2hlbWFzL3BrZy9nZW4vY3JlYXRpdmVmYWJyaWNhL2Vycm9ycy92MTtlcnJvcnN2MWIGcHJvdG8z", [file_creativefabrica_coins_v1_types]);

/**
 * @generated from message creativefabrica.errors.v1.Error
 */
export type Error = Message<"creativefabrica.errors.v1.Error"> & {
  /**
   * @generated from field: creativefabrica.errors.v1.ErrorType type = 1;
   */
  type: ErrorType;

  /**
   * @generated from oneof creativefabrica.errors.v1.Error.detail
   */
  detail: {
    /**
     * @generated from field: creativefabrica.coins.v1.CoinError coin_error = 2;
     */
    value: CoinError;
    case: "coinError";
  } | {
    /**
     * @generated from field: creativefabrica.errors.v1.NSFWError nsfw_error = 3;
     */
    value: NSFWError;
    case: "nsfwError";
  } | {
    /**
     * @generated from field: creativefabrica.errors.v1.ValidationError validation_error = 4;
     */
    value: ValidationError;
    case: "validationError";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.errors.v1.Error
 */
export type ErrorJson = {
  /**
   * @generated from field: creativefabrica.errors.v1.ErrorType type = 1;
   */
  type?: ErrorTypeJson;

  /**
   * @generated from field: creativefabrica.coins.v1.CoinError coin_error = 2;
   */
  coinError?: CoinErrorJson;

  /**
   * @generated from field: creativefabrica.errors.v1.NSFWError nsfw_error = 3;
   */
  nsfwError?: NSFWErrorJson;

  /**
   * @generated from field: creativefabrica.errors.v1.ValidationError validation_error = 4;
   */
  validationError?: ValidationErrorJson;
};

/**
 * Describes the message creativefabrica.errors.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error, {jsonType: ErrorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_errors_v1_types, 0);

/**
 * Maybe in the future we can add details of the error here
 *
 * @generated from message creativefabrica.errors.v1.NSFWError
 */
export type NSFWError = Message<"creativefabrica.errors.v1.NSFWError"> & {
};

/**
 * Maybe in the future we can add details of the error here
 *
 * @generated from message creativefabrica.errors.v1.NSFWError
 */
export type NSFWErrorJson = {
};

/**
 * Describes the message creativefabrica.errors.v1.NSFWError.
 * Use `create(NSFWErrorSchema)` to create a new message.
 */
export const NSFWErrorSchema: GenMessage<NSFWError, {jsonType: NSFWErrorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_errors_v1_types, 1);

/**
 * ValidationError lists every input violation found in a request, modeled
 * after google.rpc.BadRequest but with a machine-readable reason code.
 *
 * @generated from message creativefabrica.errors.v1.ValidationError
 */
export type ValidationError = Message<"creativefabrica.errors.v1.ValidationError"> & {
  /**
   * @generated from field: repeated creativefabrica.errors.v1.FieldViolation violations = 1;
   */
  violations: FieldViolation[];
};

/**
 * ValidationError lists every input violation found in a request, modeled
 * after google.rpc.BadRequest but with a machine-readable reason code.
 *
 * @generated from message creativefabrica.errors.v1.ValidationError
 */
export type ValidationErrorJson = {
  /**
   * @generated from field: repeated creativefabrica.errors.v1.FieldViolation violations = 1;
   */
  violations?: FieldViolationJson[];
};

/**
 * Describes the message creativefabrica.errors.v1.ValidationError.
 * Use `create(ValidationErrorSchema)` to create a new message.
 */
export const ValidationErrorSchema: GenMessage<ValidationError, {jsonType: ValidationErrorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_errors_v1_types, 2);

/**
 * @generated from message creativefabrica.errors.v1.FieldViolation
 */
export type FieldViolation = Message<"creativefabrica.errors.v1.FieldViolation"> & {
  /**
   * Dotted path of the offending input, e.g. "options.duration_seconds"
   * or "inputMedia.sourceVideo[0].durationSeconds".
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * Stable machine-readable code, e.g. "missing_option", "invalid_option",
   * "unknown_option", "missing_media", "missing_media_metadata".
   * A string rather than an enum so new codes don't require schema releases.
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * Human-readable explanation.
   *
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * @generated from message creativefabrica.errors.v1.FieldViolation
 */
export type FieldViolationJson = {
  /**
   * Dotted path of the offending input, e.g. "options.duration_seconds"
   * or "inputMedia.sourceVideo[0].durationSeconds".
   *
   * @generated from field: string field = 1;
   */
  field?: string;

  /**
   * Stable machine-readable code, e.g. "missing_option", "invalid_option",
   * "unknown_option", "missing_media", "missing_media_metadata".
   * A string rather than an enum so new codes don't require schema releases.
   *
   * @generated from field: string reason = 2;
   */
  reason?: string;

  /**
   * Human-readable explanation.
   *
   * @generated from field: string description = 3;
   */
  description?: string;
};

/**
 * Describes the message creativefabrica.errors.v1.FieldViolation.
 * Use `create(FieldViolationSchema)` to create a new message.
 */
export const FieldViolationSchema: GenMessage<FieldViolation, {jsonType: FieldViolationJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_errors_v1_types, 3);

/**
 * @generated from enum creativefabrica.errors.v1.ErrorType
 */
export enum ErrorType {
  /**
   * @generated from enum value: ERROR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_TYPE_COIN = 1;
   */
  COIN = 1,

  /**
   * @generated from enum value: ERROR_TYPE_NSFW = 2;
   */
  NSFW = 2,

  /**
   * @generated from enum value: ERROR_TYPE_VALIDATION = 3;
   */
  VALIDATION = 3,
}

/**
 * @generated from enum creativefabrica.errors.v1.ErrorType
 */
export type ErrorTypeJson = "ERROR_TYPE_UNSPECIFIED" | "ERROR_TYPE_COIN" | "ERROR_TYPE_NSFW" | "ERROR_TYPE_VALIDATION";

/**
 * Describes the enum creativefabrica.errors.v1.ErrorType.
 */
export const ErrorTypeSchema: GenEnum<ErrorType, ErrorTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_errors_v1_types, 0);

